<template>
  <div id="quality" class="container">
    <SfBreadcrumbs
        :breadcrumbs="breadcrumbs"
        class="breadcrumbs"
    />
   <OrkCmsPage page-id="son_histoire_et_ses_hommes"></OrkCmsPage>
  </div>
</template>

<script>
import {SfBreadcrumbs} from "@storefront-ui/vue"
import {OrkCmsPage} from "@/components/Ork";

export default {
  name: "Histoire",
  components: {
    SfBreadcrumbs,
    OrkCmsPage
  },
  data() {
    return {
      breadcrumbs: null,
    }
  },
  created() {
    this.setBreadcrumbs();
  },
  methods: {
    setBreadcrumbs() {
      this.breadcrumbs = [{
        text: this.$i18n.t('Home'),
        link: '/'
      }, {
        text: 'Son histoire et ses hommes',
      }];
    },
  },
}
</script>

<style lang="scss" scoped>
.error-msg {
  text-align: center;
}

h1, h2, h3 {
  text-transform: uppercase;
}

h2 {
  font-weight: bold;
  margin-top: var(--spacer-xl);
  margin-bottom: var(--spacer-lg);
}

h3 {
  font-weight: 500;
  margin-top: var(--spacer-lg);
  margin-bottom: var(--spacer-base);
}

p {
  margin: var(--spacer-base) 0;
}
</style>
